import {
  AfterViewInit,
  Component,
  EventEmitter, Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import { MatInputModule } from '@angular/material/input'
import { AddressTypeService } from '../../../../core/services/address/address-type/address-type.service'
import {
  MatCell,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderRow,
  MatRow,
  MatTable,
  MatTableDataSource,
  MatTableModule,
} from '@angular/material/table'
import { MatIcon } from '@angular/material/icon'
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator'
import { generateHexId } from '../../../../shared/utils/utils'
import { AlertPatientEditFormComponent } from './alert-patient-form/alert-patient-edit-form.component'
import {ReminderService} from '../../../../core/services/reminder/reminder/reminder.service';
import {PagedBankResponse} from '../../../../core/models/bank.model';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import {SnackbarCustomService} from '../../../../shared/components/snackbar/snackbar-custom.service';

@Component({
  selector: 'alert-patient-edit',
  imports: [
    AlertPatientEditFormComponent,
    MatInputModule,
    MatCell,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderRow,
    MatIcon,
    MatPaginator,
    MatRow,
    MatTable,
    MatTableModule,
    MatIcon,
    MatPaginatorModule,
    MatTable,
    MatSelectModule,
    MatFormFieldModule,
  ],
  templateUrl: './alert-patient-edit.component.html',
  styleUrl: './alert-patient-edit.component.scss',
  providers: [AddressTypeService,ReminderService],
  standalone: true,
})
export class AlertPatientEditComponent implements OnInit, AfterViewInit {
  constructor(
    private remiderService: ReminderService,
    private snackbar: SnackbarCustomService,
  ) {}

  item: any = {}
  itemsList: any[] = []
  @Input() idPatient: number = 0
  @Output() response: EventEmitter<any> = new EventEmitter()
  @ViewChild(MatPaginator) paginator: MatPaginator | undefined
  @ViewChild(MatTable) table: MatTable<any> | undefined

  selectedStatus: number | null = 1 // Padrão: Ativo (1)

  statusOptions = [
    { value: 0, label: 'Todos' },
    { value: 1, label: 'Ativo' },
    { value: 2, label: 'Inativo' }
  ]

  columns: any[] = [
    {
      keyColumn: 'hour',
      key: 'horarios',
      description: 'Horário',
    },
    {
      keyColumn: 'weekDays',
      key: 'dias_semana',
      description: 'Dias da Semana',
    },
    {
      keyColumn: 'description',
      key: 'mensagem_template_texto',
      description: 'Mensagem do Lembrete',
    },
    {
      keyColumn: 'action',
      key: { edit: true, delete: true },
      description: 'Ações',
    },
  ]
  tableSource: MatTableDataSource<any> = new MatTableDataSource<any>()
  displayedColumns: string[] = ['hour', 'weekDays', 'description', 'action']

  ngOnInit(): void {
    this.tableSource = new MatTableDataSource<any>(this.itemsList)
    this.getItemsList()
  }

  onStatusChange(status: number | null) {
    this.selectedStatus = status
    this.getItemsList()
  }

  getItemsList(){
    // Adiciona o parâmetro de status apenas se não for null (Todos)
    const params = this.selectedStatus !== 0 ? { status: this.selectedStatus } : {}

    this.remiderService.listReminderByIdPaciente(this.idPatient, params).subscribe({
      next: (response: any) => {
        if (response) {
          this.itemsList = response.data || [];
          this.tableSource = new MatTableDataSource<any>(this.itemsList);
          this.refreshTable();
        }
        console.log(this.itemsList, 'lista dos lembretes')
      },
      error: (err: any) => {
        console.error(err);
      }
    })
  }

  ngAfterViewInit() {
    this.refreshTable()
  }

  refreshTable() {
    if (this.paginator) {
      this.tableSource.paginator = this.paginator
    }
    if (this.table) {
      this.table.renderRows()
    }
  }

  responseForm(element: any) {
    switch (element.action) {
      case 'create':
        this.includeItem(element.item)
        return
      case 'edit':
        this.updateItem(element.item)
        return
      case 'delete':
        this.deleteItemEvent(element.index)
        return
      case 'cancel':
        this.item = {}
        return
    }
  }

  formatHour(hora: string | number): string {
    if (!hora) return '';

    // transforma em string, caso seja number
    const strHora = hora.toString().padStart(4, '0'); // garante 4 caracteres
    return strHora.slice(0, 2) + ':' + strHora.slice(2, 4);
  }

  formatWeekDays(diasSemana: any){
    return diasSemana
  }

  generateId() {
    let id = generateHexId()
    if (this.itemsList.length == 0) {
      return id
    } else {
      let idDistinct = false
      while (!idDistinct) {
        if (
          this.itemsList.findIndex((ele: any) => {
            return ele.idCreate == id
          }) == -1
        ) {
          idDistinct = true
        } else {
          id = generateHexId()
        }
      }
      return id
    }
  }

  includeItem(element: any) {
    this.itemsList.push({ ...element, idCreate: this.generateId() })
    this.tableSource = new MatTableDataSource<any>(this.itemsList)
    this.refreshTable()
  }

  updateItem(element: any) {
    let index = this.itemsList.findIndex((ele: any) => {
      return ele.idCreate == element.idCreate
    })
    this.itemsList.splice(index, 1, (({ index, ...rest }) => rest)(element))
    this.tableSource = new MatTableDataSource<any>(this.itemsList)
    this.refreshTable()
    this.item = {}
    this.response.emit(this.itemsList)
  }

  deleteItemEvent(element: any) {
    this.remiderService.deleteReminder(element.id).subscribe({
      next: (response: any) => {
        this.snackbar.success(response.message)
      },
      error: (err: PagedBankResponse) => {
      },
      complete: () => {
        this.getItemsList()
      },
    })
  }

  selectItemEvent(element: any) {
    this.item = element
  }
}
